<template>
  <div id="vip_application_success_outer">
    <div>会员申请成功</div>

    <div>{{timeValue}}s后将自动跳转至<a href="javascript:void(0)" @click="gotoVipeDetailPage">会员专属页</a></div>
  </div>
</template>

<script>
export default {
  name: "GroupApplicationSuccess",
  data() {
    return {
      timeValue: 3,
      timerFlag: null,
      isUpdated: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    httpManager() {
      return this.$store.state.http;
    }
  },
  mounted() {
    this.updateStatus();
    this.startTimer();
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    startTimer() {
      let _this = this;
      this.timeFlag = setInterval(function () {
        _this.timeValue -= 1;
        if (_this.timeValue == 0) {
          _this.clearTimer();
          _this.gotoVipeDetailPage();
        }
      },1000);
    },

    clearTimer() {
      if (this.timeFlag != null) {
        clearInterval(this.timeFlag);
        this.timeFlag = null;
      }
    },
    updateStatus() {
      let user = this.user;
      let params = {
        id: user.id,
        auditStatus: 0
      }
      let _this = this;
      this.httpManager.ajax.postUpdateUserAuditStatusRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.isUpdated = true;
          if (_this.timeValue <= 0) {
            _this.gotoVipeDetailPage();
          }
          return;
        }
      }, function (data) {

      });
    },
    gotoVipeDetailPage() {
      if (!this.isUpdated) {
        this.updateStatus();
        return;
      }
      this.$emit("gotoDetailPage");
    }
  }
}
</script>

<style scoped>
  #vip_application_success_outer {
    padding: 40px 15px;
    font-size: 1.2rem;
    text-align: center;
  }

  #vip_application_success_outer a {
    color: #cbb042;
    text-decoration: none;
  }

  #vip_application_success_outer > div:not(:last-child) {
    margin-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/group/groupApplicationVues/GroupApplicationSuccess.vue